import { cn } from "@/lib/utils";

type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  padding?: "none" | "sm" | "md" | "lg";
  noShadow?: boolean;
  interactive?: boolean;
};

const paddingMap = {
  none: "p-0",
  sm: "p-4",
  md: "p-6",
  lg: "p-8",
} as const;

export function Card({
  className,
  children,
  padding = "md",
  noShadow = false,
  interactive = false,
  ...props
}: CardProps) {
  return (
    <div
      className={cn(
        /* rounded-xl is the card radius (16px). Cards are for ITEMS, never for page
           sections; a 1px hairline and a whisper of shadow is all the separation an
           item needs on the open canvas. The old 2px border + blur + fade-in on every
           render was the boxes-floating-on-grey look this replaces. Non-interactive
           cards do not react to the cursor. */
        "rounded-xl border border-neutral-200/90 bg-white",
        !noShadow && "shadow-[0_1px_2px_rgba(9,15,57,0.04)]",
        interactive &&
          "cursor-pointer transition-[transform,box-shadow,border-color] duration-200 ease-out hover:-translate-y-0.5 hover:border-primary/25 hover:shadow-[0_8px_24px_rgba(11,99,224,0.10)] active:translate-y-0 active:shadow-[0_1px_2px_rgba(9,15,57,0.04)]",
        paddingMap[padding],
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
